/**
 * YoutubeIcon — sanitized from `assets/newSvg/youtube.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function YoutubeIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,4 C12.8554231,4 13.7316302,4.02241864 14.5816652,4.05776684 L15.5861395,4.10578357 L15.5861395,4.10578357 L16.5474575,4.16256888 L16.5474575,4.16256888 L17.447588,4.22447896 L17.447588,4.22447896 L18.2685,4.28787 L18.2685,4.28787 C20.1065,4.43702 21.5836,5.85942 21.7633,7.71109 L21.8030749,8.13562908 L21.8030749,8.13562908 L21.8780889,9.04557185 C21.9482222,9.98880444 22,11.0173333 22,12 C22,12.9826667 21.9482222,14.0112 21.8780889,14.9544296 L21.8030749,15.8643665 C21.7899654,16.0096642 21.7766556,16.1513778 21.7633,16.2889 C21.5836,18.1406 20.1065,19.563 18.2685,19.7121 L17.447588,19.7754863 L17.447588,19.7754863 L16.5474575,19.837399 L16.5474575,19.837399 L15.5861395,19.8941917 L15.5861395,19.8941917 L14.5816652,19.9422178 C13.7316302,19.977574 12.8554231,20 12,20 C11.1445923,20 10.2683828,19.977574 9.41834133,19.9422178 L8.4138582,19.8941917 L8.4138582,19.8941917 L7.45253268,19.837399 L7.45253268,19.837399 L6.55240116,19.7754863 L6.55240116,19.7754863 L5.7315,19.7121 L5.7315,19.7121 C3.89351,19.563 2.4164,18.1406 2.23668,16.2889 L2.19692159,15.8643665 L2.19692159,15.8643665 L2.12192296,14.9544296 C2.05179556,14.0112 2,12.9826667 2,12 C2,11.0173333 2.05179556,9.98880444 2.12192296,9.04557185 L2.19692159,8.13562908 C2.21002667,7.99032988 2.22333111,7.84861444 2.23668,7.71109 C2.4164,5.85942 3.89351,4.43702 5.7315,4.28787 L6.55240056,4.22447896 L6.55240056,4.22447896 L7.45253071,4.16256888 L7.45253071,4.16256888 L8.41385476,4.10578357 L8.41385476,4.10578357 L9.41833696,4.05776684 C10.2683781,4.02241864 11.1445885,4 12,4 Z M10,9.57513 L10,14.4249 C10,14.8868 10.5,15.1754 10.9,14.9445 L15.1,12.5196 C15.5,12.2887 15.5,11.7113 15.1,11.4804 L10.9,9.05551 C10.5,8.82457 10,9.11325 10,9.57513 Z"
        fill={color}
      />
    </Svg>
  );
}

export default YoutubeIcon;
